import gql from 'graphql-tag';

export default gql`
    query GetStageInfo($input: GetStageInfoInput) {
        getStageInfo(input: $input) {
            index
            stageSheetId
            stageDesc
            stageSheetColor
        }
    }
`;
